import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Quiz from '@/views/Quiz'
import Page from '@/views/Page'
import NotFound from '@/views/NotFound'
import Qualiscore from '@/views/Qualiscore'
import Filters from '@/views/Filters'
import store from '@/store'

Vue.use(Router)

const path = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' ? '/jevalue-mon-logement' : ''

export default new Router({
  mode: 'history',
  routes: [
    {
      path: path + '/enquete/:slug',
      name: 'survey',
      component: Filters
    },
    {
      path: path + '/barometre2019/',
      name: 'qualiscore',
      component: Quiz,
      beforeEnter: (to, from, next) => {
        Vue.$api.getUser(store.state.user.token)
        .then( response => {
          
          let d = response.data.participant.surveys
          if(d.qualiscore.completed && d.screening.completed)
          {
            next({ name: 'qualiscore-results' })
          }else{
            next()
          }
        })
      }
    },
    {
      path: path + '/barometre2019/resultats/:token?',
      name: 'qualiscore-results',
      component: Qualiscore,
      beforeEnter: (to, from, next) => {
        let token = to.params.token ? to.params.token : store.state.user.token
        Vue.$api.getUser(token)
        .then( response => {
          
          let d = response.data.participant.surveys
          if(d.qualiscore.completed && d.screening.completed)
          {
            next()
          }else{
            next({ name: 'qualiscore' })
          }
        })
      }
    },
    {
      path: path + '/page/:slug',
      name: 'page',
      component: Page
    },
    {
      path: path + '/',
      name: 'home',
      component: Home
    },
    {
      path: path + '/404',
      name: '404',
      component: NotFound
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      const isHash = to.hash ? to.hash.split('#') : undefined
      console.log(isHash)
      let tmp = setTimeout(() => {
        document.getElementById(isHash[1]).scrollIntoView()
        clearTimeout(tmp)
      })
    }
  }
})
